export default "__VITE_ASSET__q3Swfwnm__"